
$('.top-contents-topics-unit__switch-item').click(function () {
  if ($(this).hasClass("is-info")) {
    $(this).parent().parent().removeClass("is-event");
    $(this).parent().parent().addClass("is-info");
  } else if ($(this).hasClass("is-event")) {
    $(this).parent().parent().removeClass("is-info");
    $(this).parent().parent().addClass("is-event");
  }
});